export const UPDATE_CARREGADOR = "UPDATE_CARREGADOR";
